<template>
  <v-dialog transition="slide-x-reverse-transition" v-model="dialogModel" max-width="640">
    <ContentAttachments
      :active="active"
      :lesson-id="lessonId"
      :schedule-id="scheduleId"
      show-close
      @close="close"
    />
  </v-dialog>
</template>

<script>
import ContentAttachments from './ContentAttachments.vue';

export default {
  name: 'AttachmentsDialog',
  components: {
    ContentAttachments,
  },
  props: {
    active: {
      type: Boolean,
      required: true,
      default: true,
    },
    lessonId: {
      type: [Number, String],
      required: true,
    },
    scheduleId: {
      type: [Number, String],
      required: true,
    },
  },
  computed: {
    dialogModel: {
      get() {
        return this.active;
      },
      set(value) {
        this.$emit('dialog:change', value);
      },
    },
  },
  methods: {
    close() {
      this.$emit('dialog:change', false);
    },
  },
};
</script>
